import { TitleTextArrowCard } from '@/lib/shared/components/Cards';

import { useTranslation } from 'next-i18next';

type AllServicesCardsProps = {
  className: string;
};

const AllServicesCards = (props: AllServicesCardsProps) => {
  const { t } = useTranslation('index');

  const propertySale = t('propertySaleCard');
  const villasAndApartmentsForLife = t('villasAndApartmentsForLife');
  const propertyForRent = t('propertyForRent');
  const premiumAndLuxuryVillas = t('premiumAndLuxuryVillas');
  const concierge = t('conciergeCard');
  const anyIssuesAreSolvedForYou = t('anyIssuesAreSolvedForYou');
  const propertyManagement = t('propertyManagement');
  const passiveIncomeWithoutWorries = t('passiveIncomeWithoutWorries');

  const allServices = [
    {
      title: propertySale || '',
      text: villasAndApartmentsForLife || '',
      href: '/sale/catalog',
    },
    {
      title: propertyForRent || '',
      text: premiumAndLuxuryVillas || '',
      href: '/rent/catalog',
    },
    {
      title: concierge || '',
      text: anyIssuesAreSolvedForYou || '',
      href: '/concierge',
    },
    {
      title: propertyManagement || '',
      text: passiveIncomeWithoutWorries || '',
      href: '/propertymanagement',
    },
  ];

  return (
    <div className={props.className}>
      {allServices.map((item, index) => (
        <TitleTextArrowCard
          key={index}
          title={item.title}
          name={item.title}
          text={item.text}
          href={item.href}
        />
      ))}
    </div>
  );
};

export { AllServicesCards };
